const indianBanks = [
  "AU Small Finance Bank",
  "Axis Bank",
  "Bandhan Bank",
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Canara Bank",
  "Central Bank of India",
  "City Union Bank",
  "CSB Bank",
  "DCB Bank",
  "Dhanlaxmi Bank",
  "Equitas Small Finance Bank",
  "ESAF Small Finance Bank",
  "Federal Bank",
  "HDFC Bank",
  "HSBC India",
  "ICICI Bank",
  "IDBI Bank",
  "IDFC FIRST Bank",
  "Indian Bank",
  "Indian Overseas Bank",
  "IndusInd Bank",
  "Jammu & Kashmir Bank",
  "Karnataka Bank",
  "Karur Vysya Bank",
  "Kotak Mahindra Bank",
  "Nainital Bank",
  "North East Small Finance Bank",
  "Punjab & Sind Bank",
  "Punjab National Bank",
  "RBL Bank",
  "South Indian Bank",
  "Standard Chartered Bank India",
  "State Bank of India",
  "Suryoday Small Finance Bank",
  "Tamilnad Mercantile Bank",
  "Tamil Nadu State Apex Co-operative Bank",
  "UCO Bank",
  "Union Bank of India",
  "Unity Small Finance Bank",
  "Utkarsh Small Finance Bank",
  "Yes Bank",
];

export default indianBanks;
